import { ClientPod } from '../generated/graphql';
import { UserState } from '../store/userSlice';

/**
 * Determines the user's pod based on their client information.
 */
export function getUserPod(user: UserState): ClientPod {
  // Check if user has client with thsPod
  const client = user.profile?.client;
  if (client && 'thsPod' in client && client.thsPod) {
    return client.thsPod as ClientPod;
  }

  // Default fallback
  return ClientPod.Energy;
}
